__turbopack_context__.v({
  "container": "V8OzrG_container",
});
